import { LocalDataKeys, TDesignSystem } from '@libs/types';
import { useLocalData } from './useLocalData';

/**
 * Design generation for UI that has no owning widget (loader, error screen, …), from `configuration.designSystem`
 * persisted by the scenario thunks. Synchronous on the first render and live on every new response.
 *
 * Widgets must not use it — they render by their own `TWidget.version`.
 *
 * @returns the generation, or `undefined` when the backend never sent one
 */
export const useDesignGeneration = (): number | undefined => useLocalData<TDesignSystem>(LocalDataKeys.designSystem)?.generation;
